import { ButtonProps } from "@mui/material";

import { StyledLinkButton } from "./LinkButton.styles";

type LinkButtonProps = Omit<ButtonProps, "variant">;

/** A wrapped MUI Button component styled to fit inline like a regular text link */
export const LinkButton: React.FC<LinkButtonProps> = (props: LinkButtonProps) => {
  return <StyledLinkButton {...props} variant="text" />;
};
